import { Action, State, StateContext } from '@ngxs/store';
import { inject, Injectable } from '@angular/core';
import { EMPTY, Observable, catchError, tap } from 'rxjs';
import { HttpErrorResponse, HttpStatusCode } from '@angular/common/http';
import { ThirdPartySsoService } from '@pages/third-party-sso-authentication/services/third-party-sso.service';
import {
  LoadAuthorizationData,
  LoadAuthorizationDataCompleted,
  LoadAuthorizationDataError,
} from '@pages/third-party-sso-authentication/store/actions/third-party-sso.actions';
import { AuthorizationData } from '@kaseya-shared';
import { ToastService } from '@core/toast/toast.service';

@State({
  name: 'thirdPartySso',
})
@Injectable()
export class ThirdPartySsoState {
  private readonly thirdPartySsoService = inject(ThirdPartySsoService);
  private readonly toastService = inject(ToastService);

  @Action(LoadAuthorizationData)
  loadAuthorizationData(context: StateContext<void>, { ssoToken }: LoadAuthorizationData): Observable<AuthorizationData> {
    return this.thirdPartySsoService.getAuthorizationData(ssoToken).pipe(
      tap(authorizationData => context.dispatch(new LoadAuthorizationDataCompleted(authorizationData))),
      catchError((errorResponse: HttpErrorResponse) => {
        context.dispatch(new LoadAuthorizationDataError());

        if (errorResponse.status === HttpStatusCode.UnavailableForLegalReasons) {
          this.toastService.showErrorToast('third-party-sso.errors.ip-access');
          return EMPTY;
        }

        if (errorResponse.status === HttpStatusCode.BadRequest) {
          if (errorResponse.error === 'UserLockedOut') {
            this.toastService.showErrorToast('third-party-sso.errors.user-locked-out');
            return EMPTY;
          }

          if (errorResponse.error === 'UserMustBeActive') {
            this.toastService.showErrorToast('third-party-sso.errors.user-must-be-active');
            return EMPTY;
          }

          this.toastService.showErrorToast('third-party-sso.errors.invalid-sso');
          return EMPTY;
        }

        return EMPTY;
      })
    );
  }
}
